export default {
  props: ['courseId', 'courseLocale', 'courseName', 'courseSlug'],
  computed: {
    appStore: function appStore() {
      return useAppStore();
    },
    isJoiningHash: function isJoiningHash() {
      return this.appStore.isJoiningCourse;
    },
    isJoining: function isJoining() {
      return this.courseId in this.isJoiningHash && this.isJoiningHash[this.courseId];
    }
  },
  methods: {
    joinCourse: function joinCourse() {
      var _this = this;
      if (this.isJoining) return;
      this.setJoining(true);

      // Prevent showing gain before page changed
      this.appStore.setState({
        key: 'gainsAllowed',
        value: false
      });
      var params = {
        id: this.courseId
      };
      if (this.courseLocale) params.locale = this.courseLocale;
      this.$axios.post('/course/join/', params).then(function (response) {
        _this.$gtag('event', 'enroll_course', {
          "course_name": _this.courseName,
          "course_id": _this.courseId,
          "course_locale": _this.courseLocale
        });
        _this.$router.push({
          path: "/learning/course/".concat(_this.courseSlug)
        });
        try {
          _this.$fbPixel.trackSingle('SubmitApplication');
        } catch (e) {
          console.warn('GA not avalible');
        }
        _this.setJoining(false);
      }).catch(function (error) {
        // if (error && error.response && error.response.data && error.response.data.message) {
        //     alert(error.response.data.message)
        // }

        _this.setJoining(false);
      });
    },
    setJoining: function setJoining(state) {
      var hash = Object.assign({}, this.isJoiningHash);
      if (!state) {
        delete hash[this.courseId];
      } else {
        hash[this.courseId] = true;
      }
      this.appStore.setState({
        key: 'isJoiningCourse',
        value: hash
      });
    }
  }
};